import MicroModal from "micromodal";
import { getScrollBarWidth } from "@/scripts/helpers/library";
import { CLASSES } from "@/scripts/helpers/constants";

export default () => {
  const tabletBreakpoint = 640,
        body = $("body"),
        formButton = $(".js-editor-link"),
        modalFormVers = $("#modal-forms-versions"),
        lockClassName = "scroll-locked";

  function showModal(el) {
    MicroModal.show(el, {
      awaitCloseAnimation: true,
      disableFocus: true,
      onShow: modal => {
        if ($(window).width() < tabletBreakpoint) stopBodyScrolling(true);
        body.addClass(lockClassName).css("padding-right", getScrollBarWidth());
      },
      onClose: modal => {
        setTimeout(() => {
          if ($(window).width() < tabletBreakpoint) stopBodyScrolling(false);
          body.removeClass(lockClassName).css("padding-right", 0);
        }, 250);
      }
    });
  }

  if (modalFormVers.length){
    showModal("modal-forms-versions");

    formButton.click(function(e) {
      modalFormVers.removeClass(CLASSES.IS_OPEN);
    });
  }
};
